import type { ColumnsType } from 'antd/lib/table';

import type { TicketCategoryTableData } from './types';

export const DUMMY_SERVICE_OPTIONS = [
  {
    label: '育樂活動',
    value: '育樂活動',
  },
  {
    label: '清潔打掃',
    value: '清潔打掃',
  },
];

export const DUMMY_TICKET_CATEGORY_TABLE_DATASOURCE: TicketCategoryTableData[] =
  [
    {
      _id: '1',
      ticketName: '春季活動半價券',
      service: '育樂活動',
      description: '春季活動半價券',
      terms: '春季活動半價券',
      imageUrl:
        'https://i.pinimg.com/736x/e8/57/d9/e857d91505e0a44234a6df642684dd08.jpg',
    },
    {
      _id: '2',
      ticketName: '三八婦女節優惠券',
      service: '清潔打掃',
      description: '三八婦女節優惠券',
      terms: '三八婦女節優惠券',
      imageUrl: null,
    },
    {
      _id: '3',
      ticketName: '試營運券',
      service: '育樂活動',
      description: '試營運券',
      terms: '試營運券',
      imageUrl: null,
    },
  ];
// TODO: 這以上的都是假資料，換成真實資料後記得刪除

export const TICKET_CATEGORY_TABLE_BASIC_COLUMNS: ColumnsType<TicketCategoryTableData> =
  [
    {
      title: '票券名稱',
      dataIndex: 'ticketName',
    },
    {
      title: '服務',
      dataIndex: 'service',
    },
    {
      title: '優惠內容',
      dataIndex: 'description',
    },
    {
      title: '使用方法',
      dataIndex: 'terms',
    },
  ];
